import { Box, HStack, Text, Wrap, WrapItem } from '@chakra-ui/react';
import type { ReconciliationSummaryDto } from '../../../types/lobbyDay'
import { DISPOSITION_META } from './DispositionChip'

export function ReconciliationScorecard({ summary }: { summary: ReconciliationSummaryDto }) {
  const items: { key: keyof typeof DISPOSITION_META; count: number }[] = [
    { key: 'Excited', count: summary.excited },
    { key: 'Jilted', count: summary.jilted },
    { key: 'Betrayed', count: summary.betrayed },
    { key: 'Pending', count: summary.pending },
  ]
  return (
    <Box bg="surface" p={4} borderRadius="lg" shadow="md">
      <Wrap gap={4} align="center">
        <WrapItem>
          <Text fontWeight="bold">{summary.attendeesTagged} attendees will be tagged</Text>
        </WrapItem>
        {items.map((it) => (
          <WrapItem key={it.key}>
            <HStack gap={1}>
              <Text>{DISPOSITION_META[it.key].label}</Text>
              <Text fontWeight="semibold">{it.count}</Text>
            </HStack>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
}
